<template>
    <select ref="select" class="form-control">
        <slot></slot>
    </select>
</template>

<script>
    export default {
        props:     {
            options:     {
                required: false,
                type:     Array
            },
            modelValue:       {
                required: false
            },
            id:          {
                required: false
            },
            sorter:      {
                required: false,
                type:     Boolean,
                default:  false
            },
            placeholder: {
                required: false,
                type:     String,
                default:  ''
            },
            search:      {
                required: false,
                type:     Boolean,
                default:  true
            },
            parent:      {
                required: false,
                default:  false
            },
            template: {
                required: false,
                default: null
            },
            tags: {
                required: false,
                default: null
            }
        },
        methods:   {
            getOptions() {
                const self = this;

                let element = jQuery(self.$refs.select);

                let options = {
                    data:              self.options,
                    theme:             'bootstrap',
                    width:             null,
                    containerCssClass: ':all:',
                    sorter:            function (data) {
                        if (self.sorter) {
                            return data;
                        }

                        return data.sort(function (a, b) {
                            return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
                        });
                    }
                };

                if (self.placeholder) {
                    options.placeholder = self.placeholder;
                }

                if (!self.search) {
                    options.minimumResultsForSearch = -1;
                }

                if (self.parent) {
                    options.dropdownParent = jQuery(self.$refs.select).parent();
                }

                if (self.template) {
                    options.templateResult = self.template;
                    options.templateSelection = self.template;
                }

                if (self.tags) {
                    options.tags = true;
                    options.multiple = true;
                    options.maximumSelectionLength = 1;
                }

                return options;
            },
            init(clear = false) {
                const self = this;

                if (clear === true) {
                    jQuery(self.$refs.select)
                        .empty();
                }

                jQuery(self.$refs.select)
                // init select2
                    .select2(self.getOptions())
                    .on('focus', function (event) {
                        event.stopPropagation();
                    })
                    // emit event on change.
                    .on('change', function (event, args) {
                        if (!(args && "ignore" in args)) {
                            if (!_.isEqual(self.modelValue, jQuery(this).val())) {
                                self.$emit('update:modelValue', jQuery(this).val());
                            }

                            self.$emit('change', jQuery(this).val());
                        }
                    })
                    // emit event on selected.
                    .on('select2:select', function () {
                        if (!_.isEqual(self.modelValue, jQuery(this).val())) {
                            self.$emit('selected', jQuery(this).val());
                        }
                    })
                    .trigger('change', {ignore: true});

                self.$nextTick(() => {
                    jQuery(self.$refs.select)
                        .val(self.modelValue)
                        .trigger('change', {ignore: true})
                });
            }
        },
        mounted:   function () {
            const self = this

            self.init();
        },
        watch:     {
            modelValue:   function (value) {
                const self = this;

                // update value
                jQuery(self.$refs.select)
                    .val(value);

                jQuery(self.$refs.select)
                    .trigger('change', {ignore: true});

                self.$emit('select', value);
            },
            options: function (options) {
                const self = this;

                self.init(true);
            },
            id:      function () {
                const self = this;

                self.init(true);
            }
        },
        unmounted: function () {
            jQuery(this.$refs.select)
                .off()
                .select2('destroy')
        }
    }
</script>